import { Card, Flex, Space, theme, Typography } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EMPTY_DISPLAY_VALUE } from '@shared/constants/display';

const { Text } = Typography;

const EMPTY_VALUES = [null, undefined, ''];

export const InfoCard = ({ icon, title, record, items }) => {
  const { token: themeToken } = theme.useToken();

  const renderValue = (value) => {
    if (EMPTY_VALUES.includes(value)) {
      return <Text type='secondary'>{EMPTY_DISPLAY_VALUE}</Text>;
    }

    if (['string', 'number'].includes(typeof value)) {
      return (
        <Text strong ellipsis={{ tooltip: true }} style={{ textAlign: 'right' }}>
          {value}
        </Text>
      );
    }

    return value;
  };

  return (
    <Card
      title={
        <Space>
          <FontAwesomeIcon color={themeToken.colorPrimary} icon={icon} />
          <div>{title}</div>
        </Space>
      }
    >
      <Flex gap='small' vertical>
        {items.map(({ label, field, render }) => {
          const rawValue = record[field]; // Se obtiene el valor del campo correspondiente en 'record'
          const displayValue = render ? render(rawValue, record) : rawValue;

          return (
            <Flex key={field ?? label} gap='middle' justify='space-between'>
              <Text type='secondary' style={{ whiteSpace: 'nowrap' }}>
                {label}:
              </Text>
              {renderValue(displayValue)}
            </Flex>
          );
        })}
      </Flex>
    </Card>
  );
};